export * from './promotion/promotion.resolver';
